import { client } from '../common/client';
import { toFiboSearchResponse } from './utils/transformers';
import type { FiboSearchRequest, FiboSearchResponse, SearchAutocompleteResponse } from './utils/types';

class FiboAPIClient {
  public async getFiboSearch(params?: FiboSearchRequest): Promise<FiboSearchResponse> {
    return await client
      .get<SearchAutocompleteResponse>(`/search/autocomplete`, {
        params: { q: params?.s ?? '', currency: params?.currency },
      })
      .then((res) => toFiboSearchResponse(res.data));
  }
}

export const fiboAPIClient = new FiboAPIClient();
